import { DetectionFieldsFragment } from '../../../../../../../generated/core-api/graphql-react-query';

export default function formatDetectionGroup(detections: DetectionFieldsFragment[], detectionBadges: Map<string, number>, complianceOpenedAt: number | null) {
  const [head] = detections;
  if (!head) {
    throw new Error('Illegal State Exception: Empty detection group');
  }
  if (!head.cardId) {
    throw new Error('Illegal State Exception: Non-display detection in detection group');
  }
  const displayedAt = detectionBadges.get(head.cardId);
  const lastOccurrence = detections.map((d) => d.date).reduce((a, b) => (a > b ? a : b));
  let notificationBadge = (displayedAt && displayedAt >= lastOccurrence) ? undefined : { seen: false };
  if (!!notificationBadge && !notificationBadge.seen && lastOccurrence < complianceOpenedAt) {
    notificationBadge = { seen: true };
  }
  return {
    id: head.cardId,
    title: head.scope?.card.title ?? '',
    projectId: head.projectId,
    lastOccurrence,
    detections,
    displayedAt,
    notificationBadge,
  };
}
